/* eslint-disable import/prefer-default-export */
export const getNotification = (state) => state.notification;
